import React from "react";
import "moment/locale/hu";
import {
  Card,
  Button,
  CardTitle,
  CardImg,
  CardText,
  UncontrolledTooltip,
} from "reactstrap";
import Localization from 'react-widgets/esm/Localization';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import Dropzone from "react-dropzone";
import RFField from "../components/Form/RFField";
import NumberFormatter from "./NumberFormatter";
import TimeFormatter from "./TimeFormatter";

const colSizes = ["xs", "sm", "md", "lg", "xl"];

/**
* Dátumválasztó idővel
*/
// export const DatetimePicker = (props) => {
//   return (
//     <Localization
//       date={new DateLocalizer({
//         firstOfWeek: 1,
//       })}
//     >
//       <DatePickerRW
//         {...props}
//         parse="YYYY-MM-DD"
//         includeTime
//         onChange={props.onChange ? (v) => props.onChange(v, TimeFormatter.formatDateTime(v)) : null}
//         messages={{
//           timeButton: 'idő',
//           moveBack: 'Hátra',
//           moveForward: 'Előre',
//           moveToday: 'Ma'
//         }}
//       />
//     </Localization>
//   );
// }

// /**
// * Dátumválasztó
// */
// export const DatePicker = (props) => {
//   return (
//     <Localization
//       date={new DateLocalizer({
//         firstOfWeek: 1,
//       })}
//     >
//       <DatePickerRW
//         {...props}
//         parse="YYYY-MM-DD"
//         onChange={props.onChange ? (v) => props.onChange(v, TimeFormatter.formatDate(v)) : null}
//         messages={{
//           moveBack: 'Hátra',
//           moveForward: 'Előre',
//           moveToday: 'Ma'
//         }}
//       />
//     </Localization>
//   );
// }

export const DatetimePicker = React.forwardRef((props, ref) => {
  // Azért van így lekezelve, hogy ne kelljen mindenhol egyesével törölni a DatetimePicket-t és lecserélni az importot, ahol ez a prop jelen van
  if (props.time === false)
    return <DatePicker {...props} />
  return (
    <Localization
      date={new DateLocalizer({
        firstOfWeek: 1,
        culture: 'hu-hu'
      })}
    >
      <RFField
        type={'datetime-local'}
        {...props}
        ref={ref}
        includeTime
        timePrecision={props.timePrecision}
        formatDate={props.formatDate || TimeFormatter.FORMATS.datetime}
        // onChange={props.onChange()}
        value={props.value || props.initialValue}
        // value={'2022-03-22T09:00'}
        onChange={props.onChange}
        onSelect={props.onSelect}
        messages={{
          timeButton: 'idő',
          moveBack: 'Hátra',
          moveForward: 'Előre',
          moveToday: 'Ma'
        }}
      />
    </Localization>
  );
});

/**
* Dátumválasztó
*/
export const DatePicker = React.forwardRef((props, ref) => {
  return (
    <Localization
      date={new DateLocalizer({
        culture: "hu-hu",
        firstOfWeek: 1,
      })}
    >
      <RFField
        type={'date'}
        ref={ref}
        {...props}
        formatDate={props.formatDate || 'YYYY-MM-DD'}
        onChange={props.onChange ? (e, v) => props.onChange(v, TimeFormatter.formatDate(v)) : null}
        messages={{
          moveBack: 'Hátra',
          moveForward: 'Előre',
          moveToday: 'Ma'
        }}
      />
    </Localization>
  );
});

export const PaginationTotal = (start, to, total) => {
  return (
    <span>
      {" "}
      <Button className="text-black" style={{ backgroundColor: "#eceff1" }}>
        {start} - {to} / {total} tétel megjelenítése
      </Button>{" "}
    </span>
  );
};

export const DropZone = (props) => {
  return (
    <Dropzone {...props}>
      {({getRootProps, getInputProps}) => (
          <div {...getRootProps({ className: 'custom-dropzone ' + (props.className || '')})}>
            <input {...getInputProps()} />
            <div className="dropzone-text">
              {'Kép feltöltése!'}
            </div>
          </div>
      )}
    </Dropzone>
  );
}

export const BankCard = props => {
  const {
    bankszamlaszam,
    ibanszam,
    penzintezet,
    onDeleteClick,
    onModifyClick
  } = props;

  return (
    <Card body>
      <CardText>
        <b>Pénzintézet:</b> {penzintezet}
        <br />
        <b>Bankszámlaszám:</b> {NumberFormatter.addHyphensToStringBankszamla(bankszamlaszam)}
        <br />
        <b>IBAN szám:</b> {ibanszam}
        <br />
      </CardText>
      <div>
        {onModifyClick ? (
          <Button
            style={{ cursor: "pointer" }}
            color="primary"
            onClick={onModifyClick}
          >
            <i className="icon-pencil" aria-hidden="true" />
          </Button>
        ) : (
          <span />
        )}{" "}
        {onDeleteClick ? (
          <Button
            style={{ cursor: "pointer" }}
            color="danger"
            onClick={onDeleteClick}
          >
            <i className="fa fa-trash-o" aria-hidden="true" />
          </Button>
        ) : (
          <span />
        )}{" "}
      </div>
    </Card>
  );
};

export const FileCard = props => {
  const {
    idx,
    title,
    length,
    onViewClick,
    onDownloadClick,
    onDeleteClick,
    onLogoClick,
    activeLogo,
    mime
  } = props;

  let selector = "selector-" + title.replace(/[^a-zA-Z]/g, "");

  return (
    <Card body style={activeLogo ? { backgroundColor: "bisque" } : null}>
      <CardTitle>
        <b>{title + (activeLogo ? " (aktív logó)" : "")}</b>
      </CardTitle>
      <CardText>{length}</CardText>
      <div>
        {onViewClick ? (
          <React.Fragment>
            <Button
              color="primary"
              onClick={onViewClick}
              id={"view-" + selector}
            >
              <i className="icon-eye" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"view-" + selector}
              delay={50}
            >
              {"Fájl megtekintése"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
        {onDownloadClick ? (
          <React.Fragment>
            <Button
              color="primary"
              onClick={onDownloadClick}
              id={"download-" + selector}
            >
              <i className="fa fa-arrow-down" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"download-" + selector}
              delay={50}
            >
              {"Fájl letöltése"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
        {onDeleteClick ? (
          <React.Fragment>
            <Button
              color="danger"
              onClick={onDeleteClick}
              id={"delete-" + selector}
            >
              <i className="fa fa-trash-o" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"delete-" + selector}
              delay={50}
            >
              {"Fájl törlése"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
        {onLogoClick &&
        !activeLogo &&
        (mime === "image/jpeg" || mime === "image/png") ? (
          <React.Fragment>
            <Button
              color="success"
              onClick={onLogoClick}
              id={"logo-" + selector}
            >
              <i className="fa fa-check" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"logo-" + selector}
              delay={50}
            >
              {"Logó aktiválása"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
      </div>
    </Card>
  );
};

export const ImageCard = ({
  onViewClick,
  onDeleteClick,
  onMainImageClick,
  main,
  poster,
  content,
  src,
  hasButton = true,
  style,
  noStyle,
  backgroundColor,
  cardStyles
}) => {
  let selector = "selector-test"; // TODO FIX

  return (
    <Card inverse style={{ backgroundColor: backgroundColor || "#000", ...cardStyles }}>
      {(src || content) && (
        <CardImg
          src={src ? src : "data:image/bmp;base64," + content}
          onClick={onViewClick}
          className={!noStyle ? "custom-card-image" : ""}
          style={style}
        />
      )}
      <span style={{ width: "100%" }}>
        {!poster && (
          <React.Fragment>
            <Button
              style={{ backgroundColor: main ? "#a3a5a5" : "", width: "50%"}}
              color="secondary"
              onClick={onMainImageClick}
              id={"main-" + selector}
            >
              <i className="fa fa-flag-o" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"main-" + selector}
              delay={50}
            >
              {"Elsődleges kép kiválasztása"}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        {hasButton && (
          <React.Fragment>
            <Button
              style={{ width: poster ? "100%" : "50%" }}
              color="secondary"
              onClick={onDeleteClick}
              id={"delete-" + selector}
            >
              <i className="fa fa-trash-o" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"delete-" + selector}
              delay={50}
            >
              {"Kép törlése"}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </span>
    </Card>
  );
};

export const PhoneCard = props => {
  const {
    idx,
    orszag,
    num,
    tipus,
    szam,
    onViewClick,
    onModifyClick,
    onDeleteClick,
    onElsodlegesClick,
    isElsodleges
  } = props;

  let formatTipus = name => {
    // TODO : DROP THIS!!!!!!
    switch (name) {
      case "FAX":
        return "Fax";
      case "MOBIL":
        return "Mobiltelefon";
      case "VEZETEK":
        return "Vezetékes";
      default:
        return "Ismeretlen";
    }
  };

  return (
    <Card body style={isElsodleges ? { backgroundColor: "bisque" } : null}>
      <CardTitle>
        <b>{formatTipus(tipus) + (isElsodleges ? " (Elsődleges)" : "")}</b>
      </CardTitle>
      <CardText>
        <b>{"Telefonszám: "}</b>
        {szam}
        <br />
        <b>{"Országhívó: "}</b>
        {orszag + (num ? ' (' + num + ')' : '')}
      </CardText>
      <div>
        {onViewClick ? (
          <React.Fragment>
            <Button
              color="primary"
              onClick={onViewClick}
              id={"view-" + idx}
              onMouseDown={e => {
                if (e) {
                  e.preventDefault();
                }
              }}
            >
              <i className="icon-eye" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"view-" + idx}
              delay={50}
            >
              {"Telefonszám megtekintése"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
        {onModifyClick ? (
          <React.Fragment>
            <Button
              color="primary"
              onClick={onModifyClick}
              id={"modify-" + idx}
              onMouseDown={e => {
                if (e) {
                  e.preventDefault();
                }
              }}
            >
              <i className="icon-pencil" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"modify-" + idx}
              delay={50}
            >
              {"Telefonszám módositása"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
        {onDeleteClick ? (
          <React.Fragment>
            <Button
              color="danger"
              onClick={onDeleteClick}
              id={"delete-" + idx}
              onMouseDown={e => {
                if (e) {
                  e.preventDefault();
                }
              }}
            >
              <i className="fa fa-trash-o" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"delete-" + idx}
              delay={50}
            >
              {"Telefonszám törlése"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
        {!isElsodleges ? (
          <React.Fragment>
            <Button
              color="success"
              onClick={onElsodlegesClick}
              id={"logo-" + idx}
              onMouseDown={e => {
                if (e) {
                  e.preventDefault();
                }
              }}
            >
              <i className="fa fa-check" aria-hidden="true" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible'
              style={{ float: "left" }}
              placement="top"
              target={"logo-" + idx}
              delay={50}
            >
              {"Elsődleges"}
            </UncontrolledTooltip>
          </React.Fragment>
        ) : (
          <span />
        )}{" "}
      </div>
    </Card>
  );
};
